var render = function render(){var _vm=this,_c=_vm._self._c;return _c('defaultSec',{attrs:{"title":'订单查询'}},[_c('orderListInfo',{attrs:{"formParam":_vm.formParam}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }